import axiosInstance from "../../utils/axiosInstance";
import {
  MERCH_LIST_REQUEST,
  MERCH_LIST_SUCCESS,
  MERCH_LIST_FAIL,
  MERCH_ADD_REQUEST,
  MERCH_ADD_SUCCESS,
  MERCH_ADD_FAIL,
  MERCH_DETAILS_REQUEST,
  MERCH_DETAILS_SUCCESS,
  MERCH_DETAILS_FAIL,
} from "../Constants/MerchConstants";

// List all merchandise
export const listMerch = () => async (dispatch) => {
  try {
    dispatch({ type: MERCH_LIST_REQUEST });

    const { data } = await axiosInstance.get("/api/merch");

    dispatch({
      type: MERCH_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: MERCH_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get merchandise details by ID
export const getMerchDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: MERCH_DETAILS_REQUEST });

    const { data } = await axiosInstance.get(`/api/merch/${id}`);

    dispatch({
      type: MERCH_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: MERCH_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Add new merchandise (Admin)
export const addMerch = (merch) => async (dispatch, getState) => {
  try {
    dispatch({ type: MERCH_ADD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axiosInstance.post("/api/merch", merch, config);

    dispatch({
      type: MERCH_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: MERCH_ADD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};